module.exports = __webpack_public_path__ + "img/area-comum-04.d1e40581.png";